<template>
  <div class="date">
    <el-card class="box-card">
      <div slot="header" class="clearfix yearBtn">
        <button
          type="button"
          aria-label="前一年"
          class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
          @click="prev"
        ></button>
        <span role="button" class="el-date-picker__header-label">{{ year }}年</span>
        <button
          type="button"
          aria-label="后一年"
          @click="next"
          class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
        ></button>
      </div>
      <div class="item">
        <el-radio-group v-model="period" @change="change">
          <el-radio
            v-for="(item, index) in timeType === '半年度' ? halfYears : quarters"
            :key="index"
            :label="item.value"
            :title="item.label"
            :class="{ current: currentPeriod === item.value && year === curYear }"
          >
            <div class="label">{{ item.label }}</div>
          </el-radio>
        </el-radio-group>
      </div>
    </el-card>
  </div>
</template>
<script>
import dj from "dayjs"
import { getHalf } from "@/utils/sheet"
let quarterOfYear = require("dayjs/plugin/quarterOfYear")
dj.extend(quarterOfYear)
export default {
  name: "date",
  props: {
    date: String,
    timeType: String,
    quarters: Array,
    halfYears: Array
  },
  computed: {},
  data() {
    return {
      period: null,
      year: null,
      currentPeriod: null,
      curYear: null
    }
  },
  watch: {
    date: {
      handler(newVal) {
        this.init()
      },
      immediate: true
    }
  },
  methods: {
    init() {
      if (this.date) {
        this.year = dj(this.date).year()
        this.period = this.timeType === "半年度" ? getHalf(this.date) : dj(this.date).quarter()
      } else {
        this.year = dj(new Date()).year()
        this.period = null
      }
      this.getCurrent()
    },
    getCurrent() {
      this.curYear = dj(new Date()).year()
      this.currentPeriod =
        this.timeType === "半年度" ? getHalf(new Date()) : dj(new Date()).quarter()
    },
    change() {
      this.$emit("change", this.year, this.period ? this.period : this.currentPeriod)
    },
    prev() {
      this.year = this.year - 1
      this.change()
    },
    next() {
      this.year = this.year + 1
      this.change()
    }
  }
}
</script>
<style lang="scss" scoped>
.date {
  .yearBtn {
    text-align: center;
    padding-bottom: 12px;
  }

  .box-card {
    width: 322px;
    padding: 0 3px;
    margin-top: 0;
    position: absolute;
    z-index: 9999;
    color: #606266;
    .item {
      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        height: 100px;
        align-items: center;
        padding-left: 15px;
        padding-bottom: 12px;
        .el-radio {
          font-weight: 400;
          margin-right: 0;
          width: 50%;
          &.current {
            color: #409eff;
            font-weight: 700;
          }
          .label {
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
          }
          &.is-checked {
            .label {
              background-color: #1989fa;
              border-radius: 3px;
              color: #fff;
            }
          }
          ::v-deep {
            .el-radio__input {
              visibility: hidden;
            }
            .el-radio__label {
              &:hover {
                color: #1989fa;
              }
            }
          }
        }
      }
    }
  }

  ::v-deep {
    .el-card__header {
      margin: 12px 12px 0 12px;
      padding: unset;
    }
    .el-card__body {
      padding: 0;
    }
  }
}
</style>
